import { BookOpenIcon } from "@heroicons/react/24/outline";
import React, { FC } from "react";
import { getDocsUrl } from "@via/utils/config.tsx";
import { classNames } from "@via/utils/helpers.tsx";

type DocumentationLinkProps = {
  label?: string;
  icon?: React.ReactNode;
  wrapperClassName?: string;
  className?: string;
};

const dataPath = "/get-started/first-steps/quick-add-data/";

const DocumentationLink: FC<DocumentationLinkProps> = ({
  label = "Need Help?",
  icon = <BookOpenIcon className="h-5 w-5" />,
  wrapperClassName = "",
  className = "",
}) => {
  const docsLink = getDocsUrl(dataPath);
  return (
    <div className={classNames(wrapperClassName, "flex")}>
      <a
        href={docsLink}
        target="_blank"
        rel="noopener noreferrer"
        className={classNames(
          className,
          "inline-flex items-center gap-x-3 text-sm font-semibold leading-6 text-gray-700 hover:text-indigo-600"
        )}>
        {icon}
        {label}
      </a>
    </div>
  );
};

export default DocumentationLink;
